var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTruckFast = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 30,
  height: 30,
  viewBox: "4 10 22 11"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M12 17.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3m10.043 0a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3m3.457.5h.5v1h-1.457c0-1.38-1.12-2.5-2.5-2.5a2.5 2.5 0 0 0-2.5 2.5H14.5c0-1.38-1.122-2.5-2.5-2.5A2.5 2.5 0 0 0 9.5 19h-2v-1H8v-1.625h.585c.773 0 1.51-.275 2.11-.75H4a3.4 3.4 0 0 1 2.414-1h3.171c.773 0 1.51-.275 2.11-.75H5a3.4 3.4 0 0 1 2.414-1h3.171c.773 0 1.51-.275 2.11-.75H6a3.4 3.4 0 0 1 2-.96V10h10v6h1v-4h3.5l3 3zM21 15h3.086l-2-2H21z"
})));
export default SvgTruckFast;